import { styled } from '@mui/material';

import { Skeleton } from '../../atoms/Skeleton';
import { SUB_TOPIC_LIST_WIDE_QUERY } from '../SubTopicList/subTopicListContainer';

const Row = styled('li')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  minHeight: theme.spacing(9),
  paddingBlock: theme.spacing(1.5),
  paddingInline: theme.spacing(2),
  [SUB_TOPIC_LIST_WIDE_QUERY]: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    minHeight: theme.spacing(7),
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(3),
  },
}));

/** Placeholder mirroring a `SubTopicListItem` while the sub-topics load. */
export function SubTopicListItemSkeleton() {
  return (
    <Row aria-hidden="true">
      <Skeleton variant="text" width="45%" />
      <Skeleton variant="rounded" width={72} height={22} />
    </Row>
  );
}
